import {createSlice} from '@reduxjs/toolkit';

const initialState = {
	selectedMenu:'My Dukkan',
}

const utilitySlice = createSlice({
	name:"utility",
	initialState,
	reducers:{
		setMenu(state,action){
			state.selectedMenu=action.payload;
		},
	}
});

export const {setMenu} = utilitySlice.actions; 
export default utilitySlice.reducer;
